import fetch from '@giro/shared-utils/fetch.util';

export default async function patchApiMonitoringsIdService(id) {
  return fetch(`monitorings/${id}`, {
    method: 'PATCH',
    ms: 'MONITORING',
    auth: true,
  });
}
